export const EXCMREGION_CREATE_RESET = 'EXCMREGION_CREATE_RESET'
export const EXCMREGION_CREATE_SET_CREATED = 'EXCMREGION_CREATE_SET_CREATED'
export const EXCMREGION_CREATE_SET_ERROR = 'EXCMREGION_CREATE_SET_ERROR'
export const EXCMREGION_CREATE_SET_VIOLATIONS = 'EXCMREGION_CREATE_SET_VIOLATIONS'
export const EXCMREGION_CREATE_TOGGLE_LOADING = 'EXCMREGION_CREATE_TOGGLE_LOADING'
